// getFieldError retrives an error for the given field
import type { Field } from '@edu-flow/components/Fields/types';

const getFieldError = (field: Field, errors) => errors.find((error) => field.name === error.name);

export default getFieldError;
